import { render, staticRenderFns } from "./UploadFile.vue?vue&type=template&id=339f0d3e&"
import script from "./UploadFile.vue?vue&type=script&lang=js&"
export * from "./UploadFile.vue?vue&type=script&lang=js&"
import style0 from "./UploadFile.vue?vue&type=style&index=0&id=339f0d3e&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/agent_ai/agent-ai-builder/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('339f0d3e')) {
      api.createRecord('339f0d3e', component.options)
    } else {
      api.reload('339f0d3e', component.options)
    }
    module.hot.accept("./UploadFile.vue?vue&type=template&id=339f0d3e&", function () {
      api.rerender('339f0d3e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Common/UploadFile.vue"
export default component.exports